import { useEffect, useRef, useState } from "react";
import axios from "../api/axios";
import { useReactToPrint } from 'react-to-print';
import { CheckCircleOutlined, CloseOutlined, FilePdfOutlined } from "@ant-design/icons";
import Select from "react-select";
import Table_3 from "./APR_ReportTablesComponents/Table_3";
import Table_8 from "./APR_ReportTablesComponents/Table_8";
import Table_9 from "./APR_ReportTablesComponents/Table_9";
import Table2_7 from "../components/APR_ReportTablesComponents/Table_2.7";
import { Button, Row, Col, Modal, message, Progress } from "antd";

import Table_13 from "./APR_ReportTablesComponents/Table_13";
import Table_14 from "./APR_ReportTablesComponents/Table_14";
import Table_15 from "./APR_ReportTablesComponents/Table_15";
import Table_16 from "./APR_ReportTablesComponents/Table_16";
import Table_17 from "./APR_ReportTablesComponents/Table_17";
import Table_18 from "./APR_ReportTablesComponents/Table_18";
import Table_19 from "./APR_ReportTablesComponents/Table_19";
import Table_20 from "./APR_ReportTablesComponents/Table_20";
import Table_21 from "./APR_ReportTablesComponents/Table_21";
import Table_22 from "./APR_ReportTablesComponents/Table_22";
import Table_4 from "./APR_ReportTablesComponents/Table_4";
import Table_5 from "./APR_ReportTablesComponents/Table_5";
import Table_6 from "./APR_ReportTablesComponents/Table_6";
import Table_1 from "./APR_ReportTablesComponents/Table_1";
import Table_2 from "./APR_ReportTablesComponents/Table_2";
import Table_7 from "./APR_ReportTablesComponents/Table_7";
import Table_10 from "./APR_ReportTablesComponents/Table_10";
import Table_11 from "./APR_ReportTablesComponents/Table_11";
import Table_12 from "./APR_ReportTablesComponents/Table_12";
import { filterTrackedEntitiesByCreatedAt } from "../utils/utils";
import ReportCover from "./APR_ReportTablesComponents/ReportCover";
import useAuth from "../hooks/useAuth";
import instance from "../api/cmsapi";
import ExeAPR from "./APR_ReportTablesComponents/APRComment.js/ExecutiveSummary";
import Introduction from "./APR_ReportTablesComponents/Chapter3.js/Introduction";
import Key_Issues_Addressed from "./APR_ReportTablesComponents/Chapter3.js/Key_Issues_Addressed";
import Key_Issues_yet_to_be_Addressed from "./APR_ReportTablesComponents/Chapter3.js/Key_Issues_yet_to_be_Addressed";
import Recommendations from "./APR_ReportTablesComponents/Chapter3.js/Recommendations";
import Conclusion from "./APR_ReportTablesComponents/Chapter3.js/Conclusion";
import GeneralIntroduction from "./APR_ReportTablesComponents/Chapter1/GeneralIntroduction";
import NdpcSummary from "./APR_ReportTablesComponents/NDPC/NdpcSummary";
import { useLocationContext } from "../context/LocationContext";



// List of Tables options
const tableOptions = [
  { value: "all_tables", label: "All Tables" },
  { value: "table_1", label: "Table 1 – Proportion of the AAP Implemented by Development Dimensions" },
   { value: "table_2", label: "Table 2 – Proportion of the DMTDP Implemented" },
  { value: "table_3", label: "Table 3 – Project Register as of the end of the year" },
  { value: "table_4", label: "Table 4 –  Total number of active projects"},
  { value: "table_5", label: "Table 5 –   Distribution of Physical projects among departments of the Assembly"},
  { value: "table_6", label: "Table 6 – Project Age Analysis" },
  { value: "table_7", label: "Table 7 –  Repair and maintenance of Existing Infrastructure" },
  { value: "table_8", label: "Table 8 – Programme Register as of the end of the Year, 2024" },
  { value: "table_9", label: "Table 9 – Update on Revenue Sources as of the end of the Year (2021 – 2024) " },
  { value: "table_10", label: "Table 10 – Update on Expenditure as of the Year (2021 – 2024)" },
  { value: "table_11", label: "Table 11 –  CAPEX Budget Performance Analysis, 2024" },
  { value: "table_12", label: "Table 12 – CAPEX Budget Allocation and Implementation of active projects" },

  { value: "table_13", label: "Table 13 – Cumulative CAPEX throw forward and MTBF Envelope, 2025-2027" },
  { value: "table_14", label: "Table 14 – AMOUNT OF CAPITAL ENVELOPE SPENT ON ACTIVE PROJECTS" },
  { value: "table_15", label: "Table 15 – ESTIMATED  COST AND  COST OVERRUNS OF  ACTIVE  PROJECTS" },
  { value: "table_16", label: "Table 16 – PERFORMANCE OF  CORE  INDICATORS OF THE END OF THE  YEAR" },
  { value: "table_18", label: "Table 18 – STAFF  STRENGTHS" },
  { value: "table_19", label: "Table 19 – CAPACITY  DEVELOPMENT" },
  { value: "table_20", label: "Table 20 – LOGISTICS  ANALYSIS" },
  { value: "table_21", label: "Table 21 – UPDATE ON EVALUATIONS CONDUCTED" },
  { value: "table_22", label: "Table 22 – UPDATE ON  PARTICIPATORY  MONITORING AND  EVALUATION  (PM&E) TOOLS USED" },
  { value: "apendix_2", label: "Apendix2  – Composit Annual Action for the Year" },
];

const periodOption = [
  { value: "Q1", label: "First Quater - Q1" },
  { value: "Q2", label: "Second Quater - Q2" },
  { value: "Q3", label: "Third Quater - Q3" },
  { value: "Q4", label: "Fourth Quater - Q4" },
  { value: "yearly", label: "Yearly" }
];
const Abbreviation = [
  { value: "1D1F", label: "1D1F - One District One Factory" },
  { value: "AAP", label: "AAP - Annual Action Plan" },
  { value: "AIDS", label: "AIDS - Acquired Immune Deficiency Syndrome" },
  { value: "AMSEC", label: "AMSEC - Agricultural Mechanisation Services" },
  { value: "APR", label: "APR - Annual Progress Report" },
  { value: "ART", label: "ART - Anti-Retroviral Treatment" },
  { value: "BECE", label: "BECE - Basic Education Certificate Examination" },
  { value: "CAPEX", label: "CAPEX - Capital Expenditure" },
  { value: "CLTS", label: "CLTS - Community Led Total Sanitation" },
  { value: "CHPS", label: "CHPS - Community-Based Health Planning and Services" },
  { value: "COVID", label: "COVID - Corona Virus Disease" },
  { value: "CSOs", label: "CSOs - Civil Society Organisations" },
  { value: "DACF", label: "DACF - District Assemblies’ Common Fund" },
  { value: "DACF-RFG", label: "DACF-RFG - District Assemblies’ Common Fund Responsiveness Factor Grant" },
  { value: "EXECO", label: "EXECO - Executive Committee" },
  { value: "GHS", label: "GHS - Ghana Cedis" },
  { value: "GoG", label: "GoG - Government of Ghana" },
  { value: "HIV", label: "HIV - Human Immunodeficiency Virus" },
  { value: "HoDs", label: "HoDs - Head of Departments" },
  { value: "IGF", label: "IGF - Internally Generated Fund" },
  { value: "ISSOP", label: "ISSOP - Integrated Social Services Operating Procedure" },
  { value: "JHS", label: "JHS - Junior High School" },
  { value: "LEAP", label: "LEAP - Livelihood Empowerment Against Poverty" },
  { value: "LLINs", label: "LLINs - Long-Lasting Insecticidal Nets" },
  { value: "MAC", label: "MAC - Municipal AIDS Committee" },
  { value: "MAG", label: "MAG - Modernising Agriculture in Ghana" },
  { value: "MCD", label: "MCD - Municipal Co-ordinating Director" },
  { value: "MCE", label: "MCE - Municipal Chief Executive" },
  { value: "M&E", label: "M&E - Monitoring and Evaluation" },
  { value: "MMTDP", label: "MMTDP - Municipal Medium-Term Development Plan" },
  { value: "MP’s CF", label: "MP’s CF - Member of Parliament’s Common Fund" },
  { value: "MPCU", label: "MPCU - Municipal Planning Coordinating Unit" },
  { value: "MSEs", label: "MSEs - Micro and Small Enterprises" },
  { value: "MTDP", label: "MTDP - Medium-Term Development Plan" },
  { value: "MUSEC", label: "MUSEC - Municipal Security Council" },
  { value: "NDPC", label: "NDPC - National Development Planning Commission" },
  { value: "NGOs", label: "NGOs - Non-Governmental Organizations" },
  { value: "NHIS", label: "NHIS - National Health Insurance Scheme" },
  { value: "NSMA", label: "NSMA - Nkwanta South Municipal Assembly" },
  { value: "ORCC", label: "ORCC - Oti Regional Coordinating Council" },
  { value: "PERD", label: "PERD - Planting for Export and Rural Development" },
  { value: "PM&E", label: "PM&E - Participatory Monitoring and Evaluation" },
  { value: "PMTCT", label: "PMTCT - Prevention of Mother to Child Transmission" },
  { value: "PWDs", label: "PWDs- Persons With Disabilities" },
  { value: "SHS", label: "SHS - Senior High School" },
  { value: "SOCO", label: "SOCO - Gulf of Guinea Northern Regions Social Cohesion Project" },
  { value: "SPSS", label: "SPSS - Scientific Package for Social Scientist" },
];

function resolveContextDistrict(currentLocation, orgTree) {
  if (!currentLocation) return null;

  if (currentLocation.level === "district") {
    return currentLocation.orgUnitId
      ? { value: currentLocation.orgUnitId, label: currentLocation.name }
      : null;
  }

  if (currentLocation.level === "subdistrict") {
    const regionNode = orgTree?.children?.find((region) => region.slug === currentLocation.regionSlug);
    const districtNode = regionNode?.children?.find((district) => district.slug === currentLocation.districtSlug);

    return districtNode?.orgUnitId
      ? { value: districtNode.orgUnitId, label: districtNode.name }
      : null;
  }

  return null;
}

function buildMmdaAprType(periodValue) {
  return `MMDA_APR_${periodValue || "yearly"}`;
}

function normalizeMmdaAprStatus(status) {
  if (status == null || status === "") return null;
  return String(status).trim();
}

function hasMmdaAprRecord(assessment) {
  const status = normalizeMmdaAprStatus(assessment?.status);
  return ["Start", "Pending", "Completed", "Closed"].includes(status);
}

function buildMmdaAssessmentLookupUrl(districtId, year, type) {
  return `assessments/dpat/${districtId}/${year}/${type}`;
}

function AprReport({ embedded = false }) {

  const [dataElements, setDataElements] = useState(null);
  const [economicDataElements, setEconomicDataElements] = useState(null);
  const [socialDataElements, setSocialDataElements] = useState(null);
  const [categories, setCategories] = useState(null);
  const [districtWideConstant, setDistrictWideConstant] = useState(null);
  const [districts, setDistricts] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedYear, setSelectedYear] = useState({ value: "2025", label: "2025" });
  const [selectedPeriod, setSelectedPeriod] = useState({ value: "yearly", label: "Yearly" });
  const [selectedABB, setSelectedABB] = useState({ value: "Abbreviation", label: "Abbreviation" });
  const [selectedTocSection, setSelectedTocSection] = useState(null);
  const contentToPrint = useRef(null);
  const [progressLoad, setProgressLoad] = useState(false); // New state for loading
  const [assessmentStatusLoading, setAssessmentStatusLoading] = useState(false);
  const globalBusy = false;
  const loadPercent = 0;

      const [assessmentStatus, setAssessmentStatus] = useState(null); // New state for assessment status
  const { user } = useAuth();
  const { currentLocation, orgTree } = useLocationContext();
   const currentUserRole = user?.user?.userRoles?.find(
        (role) => role.name === "APR USER" || role.name === "RCC USER" || role.name === "NDPC USER"
    )?.name || "";
    const normalizedUserRole = currentUserRole ? currentUserRole.replace(" ", "_").toUpperCase() : "";
    const currentUsername = user?.user?.username || "";
    const currentFullName = user?.user?.fullName || "";
  const aprPayloadType = buildMmdaAprType(selectedPeriod?.value);
  // Set "All Tables" as the default selected table
  const [selectedTable, setSelectedTable] = useState({ value: "all_tables", label: "All Tables" });

  // Year options for dropdown
  const yearOptions = Array.from({ length: 6 }, (_, i) => {
    const year = 2020 + i;
    return { value: year.toString(), label: year.toString() };
  });

  useEffect(() => {
    if (!embedded) return;

    const nextDistrict = resolveContextDistrict(currentLocation, orgTree);

    setSelectedDistrict((previousDistrict) => {
      if (
        previousDistrict?.value === nextDistrict?.value &&
        previousDistrict?.label === nextDistrict?.label
      ) {
        return previousDistrict;
      }

      return nextDistrict;
    });
  }, [embedded, currentLocation, orgTree]);

  const refreshMmdaAssessmentStatus = async ({ clearOnMissing = true } = {}) => {
    if (!selectedDistrict?.value || !selectedYear?.value) {
      if (clearOnMissing) setAssessmentStatus(null);
      return null;
    }

    try {
      const response = await instance.get(
        buildMmdaAssessmentLookupUrl(
          selectedDistrict.value,
          selectedYear.value,
          aprPayloadType,
        ),
      );
      const data = response?.data;
      if (data && normalizeMmdaAprStatus(data.status)) {
        setAssessmentStatus(data);
        return data;
      }
      if (clearOnMissing) setAssessmentStatus(null);
      return null;
    } catch (error) {
      if (error?.response?.status === 404) {
        if (clearOnMissing) setAssessmentStatus(null);
        return null;
      }
      console.error("Failed to fetch MMDA APR assessment status:", error);
      return null;
    }
  };

  useEffect(() => {
    const loadAssessmentStatus = async () => {
      if (!selectedDistrict?.value || !selectedYear?.value) {
        setAssessmentStatus(null);
        setAssessmentStatusLoading(false);
        return;
      }
      setAssessmentStatusLoading(true);
      await refreshMmdaAssessmentStatus({ clearOnMissing: true });
      setAssessmentStatusLoading(false);
    };

    loadAssessmentStatus();
  }, [selectedDistrict?.value, selectedYear?.value, aprPayloadType]);

  useEffect(() => {
    pullConstantData();
  }, []);

  useEffect(() => {
    if (!embedded) {
      getData();
    }
  }, [embedded]);

  useEffect(() => {
    if (selectedDistrict && selectedYear) {
      getDistrictWideConstant(selectedDistrict.value, selectedYear.value)
    }
  }, [selectedDistrict, selectedYear]);

  const handlePrint = useReactToPrint({
    content: () => contentToPrint.current,
    documentTitle: `${selectedDistrict?.label}_APR_Report_${selectedYear.value}`,
    onBeforePrint: () => console.log("before printing..."),
    onAfterPrint: () => console.log("after printing..."),
    removeAfterPrint: true,
  });

  function pullConstantData() {

    axios.get('/dataSets/saljkJMizBZ?fields=dataSetElements[dataElement[id,name]]&paging=false')
      .then(response => {
        setDataElements(response.data.dataSetElements);
      }).catch(err => {
        console.error("Error pulling Data Elements: ", err);
      });

    axios.get('/dataSets/Xj0f6QZwYeO?fields=dataSetElements[dataElement[id,name]]&paging=false')
      .then(response => {
        setEconomicDataElements(response.data.dataSetElements);
      }).catch(err => {
        console.error("Error pulling Data Elements: ", err);
      });

    axios.get('/dataSets/cfMIscR3rdL?fields=dataSetElements[dataElement[id,name]]&paging=false')
      .then(response => {
        setSocialDataElements(response.data.dataSetElements);
      }).catch(err => {
        console.error("Error pulling Data Elements: ", err);
      });

    axios.get('/categoryOptionCombos.json?fields=id,name&paging=false')
      .then(response => {
        setCategories(response.data.categoryOptionCombos);
      }).catch(err => {
        console.error("Error pulling Category Combination:", err);
      });

  }

  function getDistrictWideConstant(district, year) {
    axios
      .get(`/dataValueSets?dataSet=saljkJMizBZ&orgUnit=${district}&startDate=${year}-01-01&endDate=${year}-12-31`)
      .then(result => {
        setDistrictWideConstant(result.data.dataValues);
        // console.log("district wide constant: ", result.data.dataValues);
      })
      .catch(err => {
        console.log(err);
      });
  }
  

  function getData() {
    const storedDistricts = localStorage.getItem("districts");
    if (storedDistricts) {
      const parsedDistricts = JSON.parse(storedDistricts);
      setDistricts(parsedDistricts);
      if (parsedDistricts.length > 0 && !selectedDistrict) {
        setSelectedDistrict(parsedDistricts[0]);
      }
      return;
    }

    axios
      .get("https://dddp.gov.gh/api/organisationUnits?level=3&paging=false")
      .then((result) => {
        let temp = [];
        result.data.organisationUnits.forEach((district) => {
          const currentDistrict = { value: district.id, label: district.displayName };
          temp.push(currentDistrict);
        });

        localStorage.setItem("districts", JSON.stringify(temp));
        setDistricts(temp);
        if (temp.length > 0 && !selectedDistrict) {
          setSelectedDistrict(temp[0]);
        }
      })
      .catch((err) => console.log(err));
  }

 

const assessmentStartDate = new Date().toISOString().split("T")[0].split("-").map(Number);

// const fetchAssessmentStatus = async () => {
//   if (!selectedDistrict?.value || !selectedYear?.value) {
//     console.error("District or year not selected");
//     return;
//   }

//   try {
//     const assessmentStatusResponse = await instance.get(
//       `assessments/dpat/${selectedDistrict.value}/${selectedYear.value}/APR`
//     );
//     const fetchedStatus = assessmentStatusResponse.data?.status || "Not Started";
//     setAssessmentStatus(assessmentStatusResponse.data);
//     console.log("Current assessment status:", fetchedStatus);
//     return fetchedStatus;
//   } catch (error) {
//     console.error("Failed to fetch assessment status:", {
//       message: error.message,
//       response: error.response?.data,
//       status: error.response?.status,
//     });
//     // message.error(`Failed to fetch status: ${error.response?.data?.message || error.message}`);
//     return null;
//   }
// };

 const handleStartAPR = async () => {
  setProgressLoad(true);

  if (hasMmdaAprRecord(assessmentStatus)) {
    message.warning(`An assessment for ${selectedYear?.label} in ${selectedDistrict?.label} is already in progress (Status: ${assessmentStatus.status}).`);
    setProgressLoad(false);
    return;
  }

  const payload = {
    id: 0,
    username: user?.user?.username || "",
    fullName: user?.user?.fullName || "",
    userRole: normalizedUserRole || "",
    type: aprPayloadType,
    districtId: selectedDistrict?.value || "",
    year: selectedYear?.value || "",
    status: "Start",
    assessmentStartDate: new Date().toISOString().split("T")[0],
    assessmentEndDate: null,
    reviewStartDate: null,
    reviewEndDate: null,
    closedDate: null,
  };

  const aprData = {};

  try {
    const assessmentResponse = await instance.post(`assessments`, payload);
    const createdAssessment = assessmentResponse?.data;
    if (createdAssessment?.status) {
      setAssessmentStatus(createdAssessment);
    }

    const refreshedAssessment = await refreshMmdaAssessmentStatus({ clearOnMissing: false });
    const fetchedStatus = normalizeMmdaAprStatus(
      refreshedAssessment?.status || createdAssessment?.status || "Start",
    );
    if (refreshedAssessment) {
      setAssessmentStatus(refreshedAssessment);
    } else if (createdAssessment?.status) {
      setAssessmentStatus(createdAssessment);
    }

    message.success({
      content: (
        <div>
          <p>Assessment started successfully (Status: {fetchedStatus || "Start"})</p>
        </div>
      ),
      duration: 3,
    });

    const commentDate = new Date().toISOString().split("T")[0];
    const commentPayload = {
      id: 0,
      username: user?.user?.username || "",
      fullName: user?.user?.fullName || "",
      userRole: normalizedUserRole || "",
      type: aprPayloadType,
      districtId: selectedDistrict?.value || "",
      year: selectedYear?.value || "",
      tableCommented: "Progress_start",
      comments: `Progress Report started automatically with status: ${fetchedStatus || "Start"}`,
      gaps: "",
      commentDate: commentDate,
      updateDate: commentDate,
      dddpDataDate: commentDate,
      dddpData: {
        indicator: "progress_report_start",
        tables: aprData,
      },
    };

    await instance.post(`comments`, commentPayload);

    message.success({
      content: (
        <div>
          <p>Comment added successfully</p>
        </div>
      ),
      duration: 3,
    });
  } catch (error) {
    console.error("Failed to process report or comment:", {
      response: error.response?.data,
      status: error.response?.status,
    });
  } finally {
    setProgressLoad(false);
  }
};

     const handlePendingAPR = async () => {
        setProgressLoad(true);
         const assessmentEndDate = new Date().toISOString().split("T")[0];
        const assessmentStartDate = assessmentStatus?.assessmentStartDate || new Date().toISOString().split("T")[0]; // Use existing start date or fallback to today

        const payload = {
             id: assessmentStatus.id,
            username: user?.user?.username,
            fullName: user?.user?.fullName,
            userRole: normalizedUserRole,
            // userRole: "DDDP_USER",
            type: aprPayloadType,
            districtId: selectedDistrict?.value,
            year: selectedYear?.value,
            status: "Pending",
            assessmentStartDate: assessmentStartDate,
            assessmentEndDate: assessmentEndDate,
            reviewStartDate: assessmentEndDate,
            reviewEndDate: null,
            closedDate: null,
        };

        const aprData = {
           
        };

        console.log("apr: ", aprData);

        try {
            // Step 1: Update assessment with PUT request
            const response = await instance.put(`assessments/${payload.id}`, payload);
            setAssessmentStatus(response.data);
            message.success({
                content: (
                    <div>
                        <p>Progress Report Sent successfully</p>
                    </div>
                ),
                duration: 3,
            });

            await refreshMmdaAssessmentStatus({ clearOnMissing: false });




        } catch (error) {
            console.error("Failed to Submit Report:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            message.error(`Failed to Submit Report: ${error.response?.data?.message || error.message}`);
        } finally {
            setProgressLoad(false);
        }
    };


       const handleCompleteAPR = async () => {
        setProgressLoad(true);
         const reviewEndDate = new Date().toISOString().split("T")[0];
         const assessmentEndDate = new Date().toISOString().split("T")[0];
        const assessmentStartDate = assessmentStatus?.assessmentStartDate || new Date().toISOString().split("T")[0]; // Use existing start date or fallback to today

        const payload = {
             id: assessmentStatus.id,
            username: user?.user?.username,
            fullName: user?.user?.fullName,
            userRole: normalizedUserRole,
            // userRole: "DDDP_USER",
            type: aprPayloadType,
            districtId: selectedDistrict?.value,
            year: selectedYear?.value,
            status: "Completed",
              assessmentStartDate: assessmentStartDate,
            assessmentEndDate: assessmentEndDate,
            reviewStartDate: assessmentStatus?.reviewStartDate || assessmentEndDate, // Use existing review start date or fallback to assessmentEndDate
            reviewEndDate: reviewEndDate,
            closedDate: null,
        };

        const aprData = {
           
        };

        console.log("apr: ", aprData);

        try {
            // Step 1: Update assessment with PUT request
            const response = await instance.put(`assessments/${payload.id}`, payload);
            setAssessmentStatus(response.data);
            message.success({
                content: (
                    <div>
                        <p>Submitted Successfully </p>
                    </div>
                ),
                duration: 3,
            });

            await refreshMmdaAssessmentStatus({ clearOnMissing: false });




        } catch (error) {
            console.error("Failed to Submit Report:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            message.error(`Failed to Submit Report: ${error.response?.data?.message || error.message}`);
        } finally {
            setProgressLoad(false);
        }
    };


      const handleCloseAPR = async () => {
        setProgressLoad(true);
         const reviewEndDate = new Date().toISOString().split("T")[0];
         const assessmentEndDate = new Date().toISOString().split("T")[0];
         const assessmentStartDate = assessmentStatus?.assessmentStartDate || new Date().toISOString().split("T")[0]; // Use existing start date or fallback to today
         const reviewCloseDate = new Date().toISOString().split("T")[0];

        const payload = {
             id: assessmentStatus.id,
            username: user?.user?.username,
            fullName: user?.user?.fullName,
            userRole: normalizedUserRole,
            // userRole: "DDDP_USER",
            type: aprPayloadType,
            districtId: selectedDistrict?.value,
            year: selectedYear?.value,
            status: "Closed",
              assessmentStartDate: assessmentStartDate,
            assessmentEndDate: assessmentEndDate,
            reviewStartDate: assessmentStatus?.reviewStartDate || assessmentEndDate, // Use existing review start date or fallback to assessmentEndDate
            reviewEndDate: reviewEndDate,
            closedDate: reviewCloseDate,
        };

        const aprData = {
           
        };

        console.log("apr: ", aprData);

        try {
            // Step 1: Update assessment with PUT request
            const response = await instance.put(`assessments/${payload.id}`, payload);
            setAssessmentStatus(response.data);
            message.success({
                content: (
                    <div>
                        <p>Submitted Successfully </p>
                    </div>
                ),
                duration: 3,
            });

            await refreshMmdaAssessmentStatus({ clearOnMissing: false });




        } catch (error) {
            console.error("Failed to Submit Report:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            message.error(`Failed to Submit Report: ${error.response?.data?.message || error.message}`);
        } finally {
            setProgressLoad(false);
        }
    };

      const handleSendBackAPR = async () => {
        setProgressLoad(true);
        const assessmentStartDate = assessmentStatus?.assessmentStartDate || new Date().toISOString().split("T")[0];
        const payload = {
            id: assessmentStatus?.id,
            username: user?.user?.username,
            fullName: user?.user?.fullName,
            userRole: normalizedUserRole,
            type: aprPayloadType,
            districtId: selectedDistrict?.value,
            year: selectedYear?.value,
            status: "Start",
            assessmentStartDate,
            assessmentEndDate: null,
            reviewStartDate: null,
            reviewEndDate: null,
            closedDate: null,
        };

        try {
            const response = await instance.put(`assessments/${payload.id}`, payload);
            setAssessmentStatus(response.data);
            message.success("Report sent back to District for improvement");
        } catch (error) {
            console.error("Failed to send report back:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            message.error(`Failed to send back report: ${error.response?.data?.message || error.message}`);
        } finally {
            setProgressLoad(false);
        }
      };
  // Handler for Table selection
  const handleTableSelection = (selectedOption) => {
    setSelectedTable(selectedOption);
    // console.log("Selected Table:", selectedOption);
  };
 const showConfirm = () => {
    Modal.confirm({
      title: 'Start Report',
      content: `Do you want to start the Progress Report for this district?`,
      okText: 'Yes',
      cancelText: 'No',
      
      onOk() {
        handleStartAPR(); // Trigger the original endpoint call
      },
      onCancel() {
        // Do nothing on cancel
      },
    });
  };

  const showPending = () => {
      Modal.confirm({
        title: 'SUBMIT APR TO RCC',
        content: `Do you want to submit progress report to RCC for this district?`,
        okText: 'Yes',
        cancelText: 'No',
        
        onOk() {
          handlePendingAPR(); // Trigger the original endpoint call
        },
        onCancel() {
          // Do nothing on cancel
        },
      });
    };
  
    const showCompleted = () => {
      Modal.confirm({
        title: 'APPROVE MMDA REPORT',
        content: `Do you want to approve ${selectedDistrict?.label} report and forward to NDPC?`,
        okText: 'Yes',
        cancelText: 'No',
        
        onOk() {
          handleCompleteAPR(); // Trigger the original endpoint call
        },
        onCancel() {
          // Do nothing on cancel
        },
      });
    };

     const showSendBackToDistrict = () => {
      Modal.confirm({
        title: 'SEND BACK TO DISTRICT',
        content: `Do you want to send this report back to the District for improvement?`,
        okText: 'Yes',
        cancelText: 'No',
        onOk() {
          handleSendBackAPR();
        },
      });
    };


     const showClosed = () => {
      Modal.confirm({
        title: 'CLOSE PROGRESS REPORT',
        content: `Do you want to close progress report for this district?`,
        okText: 'Yes',
        cancelText: 'No',
        
        onOk() {
          handleCloseAPR(); // Trigger the original endpoint call
        },
        onCancel() {
          // Do nothing on cancel
        },
      });
    };

     const hasSelectedDistrict = Boolean(selectedDistrict?.value);
     const isAprUser = normalizedUserRole === "APR_USER";
     const isRccUser = normalizedUserRole === "RCC_USER";
     const isNdpcUser = normalizedUserRole === "NDPC_USER";
     const workflowStatus = assessmentStatus?.status || "Not started";
     const workflowStatusKey = String(workflowStatus).toLowerCase();
     const workflowStatusTheme =
       workflowStatusKey === "start"
         ? {
             background: "#eff6ff",
             border: "#dbeafe",
             accent: "#3b82f6",
             title: "#1e3a8a",
             subtitle: "#334155",
           }
         : workflowStatusKey === "pending"
           ? {
               background: "#fff7ed",
               border: "#ffedd5",
               accent: "#f59e0b",
               title: "#92400e",
               subtitle: "#7c2d12",
             }
           : workflowStatusKey === "completed" || workflowStatusKey === "closed"
             ? {
                 background: "#f1f8eb",
                 border: "#d8e7cc",
                 accent: "#52c41a",
                 title: "#2f4f23",
                 subtitle: "#344b2c",
               }
             : {
                 background: "#f8fafc",
                 border: "#e2e8f0",
                 accent: "#64748b",
                 title: "#1f2937",
                 subtitle: "#475569",
               };
     const workflowStatusMessage =
       workflowStatusKey === "start"
         ? "Report is in progress. Complete narrative sections and submit to RCC when ready."
         : workflowStatusKey === "pending"
           ? "Report has been submitted to RCC and is awaiting review."
           : workflowStatusKey === "completed"
             ? "This report has been approved and submitted to NDPC successfully."
             : workflowStatusKey === "closed"
               ? "This report has been closed by NDPC."
               : "Select and update the report to continue the workflow.";
     const isNdpcApproved = assessmentStatus?.status === "Completed" || assessmentStatus?.status === "Closed";
     const reportStarted = hasMmdaAprRecord(assessmentStatus);
     const hideTableDis =
       !assessmentStatus ||
       (isAprUser && assessmentStatus?.status !== "Start") ||
       (isRccUser && assessmentStatus?.status !== "Pending") ||
       (isNdpcUser && !isNdpcApproved);
     const statusBadgeClassName =
       assessmentStatus?.status === "Closed"
         ? "border-destructive/20 bg-destructive/10 text-destructive"
         : assessmentStatus?.status === "Completed"
           ? "border-success/20 bg-success/10 text-success"
          : assessmentStatus?.status === "Pending"
            ? "border-destructive/20 bg-destructive/10 text-destructive"
             : assessmentStatus?.status === "Start"
               ? "border-primary/20 bg-primary/10 text-primary"
               : "border-border bg-muted text-muted-foreground";
     const currentWorkspaceLabel =
       selectedTable?.value === "all_tables" ? "All APR tables" : selectedTable?.label || "APR workspace";
     const buttonTextStyle = { color: "white", fontSize: "14px", fontWeight: "bold" };
     const actionButtonSpacing = embedded ? {} : { marginTop: "10px" };
     const emptyDistrictMessage = embedded
       ? "Select a district from the left sidebar to load the APR workspace."
       : "Select a district to load the APR workspace.";

     const startReportAction =
       hasSelectedDistrict &&
       !hasMmdaAprRecord(assessmentStatus) &&
       isAprUser ? (
         <Button
           type="primary"
           onClick={showConfirm}
           style={{
             backgroundColor: "#1890ff",
             borderColor: "#1890ff",
             ...actionButtonSpacing,
           }}
           loading={progressLoad}
         >
           <span style={buttonTextStyle}>Start Progress Report for  {selectedYear?.value}</span>
         </Button>
       ) : null;

     const submitToRccAction =
       hasSelectedDistrict &&
       assessmentStatus?.status === "Start" &&
       isAprUser ? (
         <Button
           type="primary"
           onClick={showPending}
           style={{
             backgroundColor: "#ce7e00",
             borderColor: "#ce7e00",
             ...actionButtonSpacing,
           }}
           loading={progressLoad}
         >
           <span style={buttonTextStyle}>Submit Progress Report to RCC</span>
         </Button>
       ) : null;

     const approveMmdaAction =
       hasSelectedDistrict &&
       assessmentStatus?.status === "Pending" &&
       isRccUser ? (
         <Button
           type="primary"
           onClick={showCompleted}
           style={{
             backgroundColor: "#048311ff",
             borderColor: "#048311ff",
             ...actionButtonSpacing,
           }}
           loading={progressLoad}
         >
           <span style={buttonTextStyle}>Approve District Report</span>
         </Button>
       ) : null;

     const sendBackToDistrictAction =
       hasSelectedDistrict &&
       assessmentStatus?.status === "Pending" &&
       isRccUser ? (
         <Button
           type="primary"
           onClick={showSendBackToDistrict}
           style={{
             backgroundColor: "#d97706",
             borderColor: "#d97706",
             ...actionButtonSpacing,
           }}
           loading={progressLoad}
         >
           <span style={buttonTextStyle}>Send Back to District</span>
         </Button>
       ) : null;

     const closeReportAction =
       hasSelectedDistrict &&
       assessmentStatus?.status === "Completed" &&
       isNdpcUser ? (
         <Button
           type="primary"
           onClick={showClosed}
           style={{
             backgroundColor: "#b60000ff",
             borderColor: "#b60000ff",
             ...actionButtonSpacing,
           }}
           loading={progressLoad}
         >
           <span style={buttonTextStyle}>Close Report</span>
         </Button>
       ) : null;

     const downloadReportAction = (
       <Button
         type="primary"
         icon={<FilePdfOutlined style={{ fontSize: "20px", color: "white", fontWeight: "bold" }} />}
         onClick={() => {
           if (contentToPrint.current) {
             handlePrint();
           } else {
             console.log("Content is not available for printing.");
           }
         }}
         disabled={!selectedDistrict}
         style={{
           backgroundColor: "#1890ff",
           borderColor: "#1890ff",
           height: "35px",
           padding: "0 15px",
           ...actionButtonSpacing,
         }}
       >
         <span style={buttonTextStyle}>Download PDF</span>
       </Button>
     );

  const workflowStatusBanner = (bannerKey) => (
    <div
      key={bannerKey}
      className={embedded ? "mb-4 w-full" : "col-12"}
      style={{
        borderRadius: 8,
        padding: "12px 14px",
        background: workflowStatusTheme.background,
        border: `1px solid ${workflowStatusTheme.border}`,
        borderLeft: `4px solid ${workflowStatusTheme.accent}`,
        marginTop: bannerKey === "bottom" ? (embedded ? 8 : 20) : 0,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 10,
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: 10, minWidth: 0 }}>
          <CheckCircleOutlined style={{ color: workflowStatusTheme.accent, fontSize: 18, marginTop: 2 }} />
          <div style={{ minWidth: 0 }}>
            <p style={{ margin: 0, color: workflowStatusTheme.title, fontSize: 20, fontWeight: 500, lineHeight: 1.25 }}>
              Report Status: {workflowStatus}
            </p>
            <p style={{ margin: "4px 0 0", color: workflowStatusTheme.subtitle, fontSize: 13, lineHeight: 1.4 }}>
              {workflowStatusMessage}
            </p>
          </div>
        </div>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#9ca3af",
            fontSize: 12,
            lineHeight: 1,
            cursor: "default",
            marginTop: 2,
          }}
        >
          <CloseOutlined />
        </span>
      </div>
    </div>
  );

  const reportContent = (
    <>
      <style>
        {`
          .apr-report-page .card > .card-body {
            padding-left: 0 !important;
            padding-right: 0 !important;
          }
        `}
      </style>
      {globalBusy && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 10050,
            background: "rgba(15, 23, 42, 0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(3px)",
          }}
        >
          <div
            style={{
              textAlign: "center",
              background: "#fff",
              padding: "18px 22px",
              borderRadius: 12,
              boxShadow: "0 16px 36px rgba(0,0,0,0.18)",
              minWidth: 160,
            }}
          >
            <Progress
              type="circle"
              percent={Math.min(100, Math.round(loadPercent))}
              size={72}
              strokeColor={{ "0%": "#1890ff", "100%": "#22c55e" }}
            />
            <p style={{ marginTop: 10, marginBottom: 0, color: "#64748b", fontSize: 12 }}>Loading…</p>
          </div>
        </div>
      )}
      {embedded ? (
        <div className="rounded-2xl border border-border bg-card p-6 shadow-sm">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
            <div className="space-y-2">
              <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">
                Progress Report
              </p>
              <div>
                <h1 className="text-2xl font-semibold text-foreground md:text-3xl">
                  Annual Progress Report
                </h1>
                <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
                  Prepare, review, and export APR tables for the district selected in the sidebar and reporting period.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
              <div className="rounded-xl border border-border bg-background px-4 py-3">
                <p className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">Year</p>
                <p className="mt-1 text-sm font-medium text-foreground">{selectedYear?.value || "Not selected"}</p>
              </div>
              <div className="rounded-xl border border-border bg-background px-4 py-3">
                <p className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">District</p>
                <p className="mt-1 text-sm font-medium text-foreground">{selectedDistrict?.label || "Select in sidebar"}</p>
              </div>
              <div className="rounded-xl border border-border bg-background px-4 py-3">
                <p className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">Workflow</p>
                <span className={`mt-1 inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${statusBadgeClassName}`}>
                  {workflowStatus}
                </span>
              </div>
            </div>
          </div>
          {isNdpcUser && !isNdpcApproved && hasSelectedDistrict ? (
            <div className="mt-4 rounded-xl border border-destructive/20 bg-destructive/10 px-4 py-3 text-sm text-destructive">
              NDPC can only view this APR after RCC final approval. Current status is pending regional approval.
            </div>
          ) : null}
        </div>
      ) : (
        <div className="page-header">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">Home</li>
            <li className="breadcrumb-item active">Annual Progress Report (APR)</li>
          </ol>
        </div>
      )}

      <div className={embedded ? "space-y-6" : "main-container"}>
        {hasSelectedDistrict && workflowStatusBanner("top")}
        <div className={embedded ? "rounded-2xl border border-border bg-card p-5 shadow-sm" : ""}>
          <div className={embedded ? "grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-5" : "row gutters mb-3"}>
            <div className={embedded ? "space-y-2" : "col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12"}>
              {embedded && (
                <label className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
                  Year
                </label>
              )}
              <Select
                onChange={(val) => setSelectedYear(val)}
                options={yearOptions}
                value={selectedYear}
                placeholder="Select Year"
              />
            </div>
            {!embedded && districts && (
              <div className={embedded ? "space-y-2" : "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"}>
                {embedded && (
                  <label className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
                    District
                  </label>
                )}
                <Select
                  onChange={(val) => {
                    setSelectedDistrict({ value: val.value, label: val.label });
                  }}
                  options={districts}
                  value={selectedDistrict}
                  isSearchable
                  placeholder="Select District"
                />
              </div>
            )}

            <div className={embedded ? "space-y-2" : "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"}>
              {embedded && (
                <label className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
                  Table
                </label>
              )}
              <Select
                onChange={handleTableSelection}
                options={tableOptions}
                value={selectedTable}
                isSearchable
                placeholder="Select Table"
              />
            </div>
            <div className={embedded ? "space-y-2" : "col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12"}>
              {embedded && (
                <label className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
                  Period
                </label>
              )}
              <Select
                onChange={setSelectedPeriod}
                options={periodOption}
                value={selectedPeriod}
                placeholder="Select Report Period"
              />
            </div>
            <div className={embedded ? "space-y-2" : "col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12"}>
              {embedded && (
                <label className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
                  Abbreviation
                </label>
              )}
              <Select
                onChange={setSelectedABB}
                options={Abbreviation}
                value={selectedABB}
                placeholder="Select Abbreviation"
              />
            </div>
          </div>
        </div>

        <div className={embedded ? "rounded-2xl border border-border bg-card p-5 shadow-sm" : ""}>
          {embedded && (
            <div className="mb-5 flex flex-col gap-3 border-b border-border pb-4 lg:flex-row lg:items-center lg:justify-between">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">
                  Report Workspace
                </p>
                <h2 className="mt-1 text-lg font-semibold text-foreground">{currentWorkspaceLabel}</h2>
              </div>
              <p className="text-sm text-muted-foreground">
                {selectedDistrict?.label || "Select a district"} / {selectedYear?.value || "Year"} / {selectedPeriod?.label || "Period"}
              </p>
            </div>
          )}

          {assessmentStatusLoading && (
            <div className="mb-5 flex items-center gap-4 rounded-xl border border-primary/25 bg-primary/10 px-4 py-4 text-sm shadow-sm">
              <span className="h-9 w-9 shrink-0 rounded-full border-4 border-primary/25 border-t-primary animate-spin" />
              <div>
                <p className="font-semibold text-foreground">Loading workflow status</p>
                <p className="mt-0.5 text-muted-foreground">
                  Checking the selected district and year before opening the progress report actions.
                </p>
              </div>
            </div>
          )}

          <div className={embedded ? "space-y-5" : "row gutters mb-3"}>

                 {/* <Col span={10} className="gutter-row">
                  {(!assessmentStatus || ![null, "Start", "Pending", "Completed", "Closed"].includes(assessmentStatus?.status)) &&
                    normalizedUserRole !== "APR_RCC" &&
                    normalizedUserRole !== "NDPC_USER" && (
                      <Button
                        type="primary"
                        onClick={showConfirm} // Use the confirmation popup instead of directly calling handleStartAssessmentSubmit
                        style={{
                          backgroundColor: "#1890ff",
                          borderColor: "#1890ff",
                        }}
                        loading={progressLoad}
                      >
                        <span style={{ color: "white", fontSize: "14px", fontWeight: "bold" }}>
                          CLICK TO START PROGRESS REPORT FOR {selectedYear?.value}
                        </span>
                      </Button>
                    )}
                </Col> */}


            {embedded ? (
              <div className="flex flex-wrap items-center gap-3">
                {startReportAction}
                {submitToRccAction}
                {sendBackToDistrictAction}
                {approveMmdaAction}
                {closeReportAction}
                <div className="sm:ml-auto">{downloadReportAction}</div>
              </div>
            ) : (
              <>
                <Col span={10} className="gutter-row">
                  {startReportAction}
                </Col>
              </>
            )}

            {!hasSelectedDistrict && (
              <div className={embedded ? "rounded-2xl border border-dashed border-border bg-muted/20 p-6 text-sm text-muted-foreground" : "card"}>
                {embedded ? (
                  <p>{emptyDistrictMessage}</p>
                ) : (
                  <div className="card-body">
                    <p>{emptyDistrictMessage}</p>
                  </div>
                )}
              </div>
            )}

            {hasSelectedDistrict && selectedTable && selectedTable.value === "all_tables" && (
              <em ref={contentToPrint}>
                <style>
                  {`
                    .apr-report-print-root {
                      font-family: "Source Sans 3", "Segoe UI", system-ui, -apple-system, BlinkMacSystemFont,
                        "Helvetica Neue", Arial, sans-serif;
                      font-size: 14px;
                      line-height: 1.55;
                      color: #0f172a;
                      -webkit-font-smoothing: antialiased;
                      font-feature-settings: "kern" 1, "liga" 1;
                    }
                    .apr-report-print-root h2,
                    .apr-report-print-root h3,
                    .apr-report-print-root h4,
                    .apr-report-print-root h5 {
                      font-family: inherit;
                      font-weight: 600;
                      letter-spacing: -0.02em;
                      color: #0f172a;
                    }
                    .apr-report-print-root h2 {
                      font-size: 1.35rem;
                      margin: 1.75rem 0 1rem;
                    }
                    .apr-report-print-root h3 {
                      font-size: 1.15rem;
                      margin: 1.5rem 0 0.85rem;
                    }
                    .apr-report-print-root small,
                    .apr-report-print-root .text-muted {
                      font-size: 0.8125rem;
                      color: #64748b !important;
                    }
                    .apr-report-print-root .table-responsive,
                    .apr-report-print-root .screen-view-tables {
                      width: 100%;
                      max-width: 100%;
                      overflow-x: auto;
                      -webkit-overflow-scrolling: touch;
                      margin: 0 0 1.25rem;
                      border-radius: 10px;
                      border: 1px solid #e2e8f0;
                      background: #fff;
                      box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
                    }
                    .apr-report-print-root .screen-view-tables {
                      padding: 0.5rem 0;
                      box-sizing: border-box;
                    }
                    .apr-report-print-root .table-responsive table,
                    .apr-report-print-root .screen-view-tables table {
                      margin-bottom: 0;
                      font-size: 13px;
                      min-width: min(100%, 520px);
                    }
                    .apr-report-print-root table.table,
                    .apr-report-print-root table.table-bordered {
                      width: 100%;
                      border-collapse: separate;
                      border-spacing: 0;
                      font-size: 13px;
                      line-height: 1.45;
                    }
                    .apr-report-print-root table.table-bordered {
                      border-radius: 0;
                      overflow: visible;
                      box-shadow: none;
                      border: none;
                    }
                    .apr-report-print-root .table-responsive table.table-bordered,
                    .apr-report-print-root .screen-view-tables table.table-bordered {
                      border-radius: 8px;
                      overflow: hidden;
                      box-shadow: inset 0 0 0 1px #e2e8f0;
                    }
                    .apr-report-print-root table.table-bordered thead th {
                      background: linear-gradient(180deg, #f1f5f9 0%, #e2e8f0 100%);
                      font-weight: 600;
                      color: #0f172a;
                      border-color: #cbd5e1 !important;
                      padding: 0.5rem;
                      white-space: normal;
                      font-size: 11px;
                      letter-spacing: 0.01em;
                      line-height: 1.25;
                      vertical-align: bottom;
                      min-width: 3rem;
                      max-width: 10rem;
                      word-wrap: break-word;
                      hyphens: auto;
                    }
                    .apr-report-print-root table.table-bordered tbody td {
                      border-color: #e2e8f0 !important;
                      vertical-align: middle;
                      padding: 0.5rem;
                      word-break: break-word;
                      hyphens: auto;
                      color: #1e293b;
                    }
                    .apr-report-print-root .apr-chart-wrap {
                      position: relative;
                      width: 100%;
                      max-width: 100%;
                      min-height: 280px;
                      margin: 0 0 1.25rem;
                    }
                    .apr-report-print-root .apr-chart-wrap--pie {
                      min-height: min(55vh, 420px);
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    }
                    .apr-report-print-root canvas {
                      max-width: 100% !important;
                    }
                    .apr-report-print-root table.table-bordered tbody tr:nth-child(even) td {
                      background-color: #f8fafc;
                    }
                    .apr-report-print-root table.table-bordered tbody tr:hover td {
                      background-color: #f1f5f9;
                    }
                    .apr-report-print-root .card {
                      border-radius: 12px;
                      border: 1px solid #e2e8f0;
                      box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
                      overflow: hidden;
                      margin-bottom: 1.25rem;
                      background: #fff;
                    }
                    .apr-report-print-root .card-header {
                      font-weight: 600;
                      font-size: 0.9375rem;
                      background: #f8fafc;
                      border-bottom: 1px solid #e2e8f0;
                      padding: 0.75rem 1rem;
                    }
                    .apr-report-print-root .card-body {
                      padding: 0.75rem 0;
                    }
                    @media print {
                      .apr-report-print-root .table-responsive,
                      .apr-report-print-root .screen-view-tables {
                        overflow: visible;
                        box-shadow: none;
                      }
                    }
                  `}
                </style>
                <div className="apr-report-print-root">
                <div className="row gutters">
                 
                  {selectedDistrict && selectedYear &&
                    <ReportCover 
                    district={selectedDistrict} 
                    year={selectedYear?.value}
                    period={selectedPeriod?.value}
                    />}
                </div>

                 {reportStarted && (
                    <>
                     <h2 style={{ textAlign: "center" }}>EXECUTIVE SUMMARY</h2>
                    <ExeAPR
                    year={selectedYear?.value}
                   district={selectedDistrict?.value}
                     hideTableDis={hideTableDis}
                      assessmentStatus = {assessmentStatus?.status !== "Completed" }
                        assessmentStatus1 = {assessmentStatus?.status !== "Closed" }
                  />
                   </>
                      )}
                      

                      <h2 style={{ textAlign: "center" }}>CHAPTER ONE (1)</h2>    
                       {reportStarted && (
                    <>
                     <h2 style={{ textAlign: "center" }}>GENERAL INFORMATION</h2>
                    <GeneralIntroduction
                    year={selectedYear?.value}
                   district={selectedDistrict?.value}
                     hideTableDis={hideTableDis}
                      assessmentStatus = {assessmentStatus?.status !== "Completed" }
                        assessmentStatus1 = {assessmentStatus?.status !== "Closed" }
                  />
                   </>
                      )}
                   <Table_1
                year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value}   hideTableDis={hideTableDis}  
                 assessmentStatus = {assessmentStatus?.status === "Pending" }
                  assessmentStatus1 = {assessmentStatus?.status !== "Closed" }
                  normalizedUserRole = {isNdpcUser}

                
                />
                <Table_2
                      year={selectedYear?.value} 
                      district={selectedDistrict?.value} 
                      period={selectedPeriod?.value} 
                      hideTableDis={hideTableDis}
                      />

                 <h2 style={{ textAlign: "center" }}>CHAPTER TWO (2)</h2>           
                <Table_3 
              year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis}/>
                 <Table_4 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                <Table_5 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value}  hideTableDis={hideTableDis}/>
                <Table_6 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                <Table_7 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                <Table_8 
                year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                <Table_9 
                year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                 <Table_10
                year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />               
                 <Table_11
                year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                  <Table_12
                year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                 <Table_13 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                <Table_14 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                <Table_15 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                   {(dataElements && categories && districtWideConstant) && <Table_16
                  year={selectedYear?.value}
                  district={selectedDistrict?.value}
                  categories={categories}
                  dataElements={dataElements}
                  districtWideConstant={districtWideConstant}
                  economicDataElements={economicDataElements}
                  socialDataElements={socialDataElements}
                  period={selectedPeriod?.value}
                  hideTableDis={hideTableDis}
                />}
                <Table_17 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                <Table_18 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                <Table_19 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis} />
                <Table_20 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value}hideTableDis={hideTableDis} />
                <Table_21 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value}hideTableDis={hideTableDis} />
                <Table_22 year={selectedYear?.value} district={selectedDistrict?.value} period={selectedPeriod?.value} hideTableDis={hideTableDis}/>

                      {reportStarted && (
                      <>
                <h2 style={{ textAlign: "center" }}>CHAPTER THREE (3)</h2>


                    <Introduction
                    year={selectedYear?.value}
                   district={selectedDistrict?.value}
                     hideTableDis={hideTableDis}
                     assessmentStatus = {assessmentStatus?.status !== "Completed" }
                      assessmentStatus1 = {assessmentStatus?.status !== "Closed" }
                  />
                   <Key_Issues_Addressed
                    year={selectedYear?.value}
                   district={selectedDistrict?.value}
                     hideTableDis={hideTableDis}
                      assessmentStatus = {assessmentStatus?.status !== "Completed" }
                       assessmentStatus1 = {assessmentStatus?.status !== "Closed" }
                  />
                   <Key_Issues_yet_to_be_Addressed
                    year={selectedYear?.value}
                   district={selectedDistrict?.value}
                     hideTableDis={hideTableDis}
                      assessmentStatus = {assessmentStatus?.status !== "Completed" }
                      assessmentStatus1 = {assessmentStatus?.status !== "Closed" }
                  />
                   <Recommendations
                    year={selectedYear?.value}
                   district={selectedDistrict?.value}
                     hideTableDis={hideTableDis}
                      assessmentStatus = {assessmentStatus?.status !== "Completed" }
                        assessmentStatus1 = {assessmentStatus?.status !== "Closed" }
                  />
                  <Conclusion
                    year={selectedYear?.value}
                   district={selectedDistrict?.value}
                     hideTableDis={hideTableDis}
                      assessmentStatus = {assessmentStatus?.status !== "Completed" }
                        assessmentStatus1 = {assessmentStatus?.status !== "Closed" }
                  />
                  </>
                      )}

                     {(assessmentStatus?.status === "Completed" || assessmentStatus?.status === "Closed") && (
                    <>
                   
                    <NdpcSummary
                    year={selectedYear?.value}
                   district={selectedDistrict?.value}
                     hideTableDis={hideTableDis}
                     
                       assessmentStatus1 = {assessmentStatus?.status !== "Closed" }
                  />
                   </>
                      )}
                    
                </div>
              </em>
            )}

          
            
            

            {hasSelectedDistrict && workflowStatusBanner("bottom")}

            {hasSelectedDistrict && !embedded && (
              <>
                <Col span={10} className="gutter-row">
                  {submitToRccAction}
                </Col>

                <Col span={10} className="gutter-row">
                  {sendBackToDistrictAction}
                </Col>

                <Col span={10} className="gutter-row">
                  {approveMmdaAction}
                </Col>

                <Col span={10} className="gutter-row">
                  {closeReportAction}
                </Col>

                <div style={{ textAlign: "right" }}>
                  {downloadReportAction}
                </div>
              </>
            )}

            
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_1" && <Table_1 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_2" && <Table_2 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_3" && <Table_3 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_4" && <Table_4 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_5" && <Table_5 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_6" && <Table_6 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_7" && <Table_7 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_8" && <Table_8 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_9" && <Table_9 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_10" && <Table_10 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_11" && <Table_11 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_12" && <Table_12 />}

        
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_13" && <Table_13 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_14" && <Table_14 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_15" && <Table_15 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_16" && <Table_16 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_17" && <Table_17 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_18" && <Table_18 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_19" && <Table_19 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_20" && <Table_20 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_21" && <Table_21 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_22" && <Table_22 />}
            {hasSelectedDistrict && selectedTable && selectedTable.value === "table_2.7" && <Table2_7 />}

            {hasSelectedDistrict && selectedTable && !["all_tables",   "table_1", "table_2", "table_3", "table_4", "table_5", "table_6", "table_7", "table_8", "table_9", 
              "table_10","table_11","table_13","table_14","table_15","table_16","table_17","table_18","table_19","table_20","table_21","table_22"
            ].includes(selectedTable.value) && (
              <div className="col-12">
                <h3 className={embedded ? "mb-3 text-lg font-semibold text-foreground" : ""}>{selectedTable.label}</h3>
                <div className={embedded ? "rounded-2xl border border-border bg-muted/20 p-5" : "card"}>
                  <div className={embedded ? "text-sm font-medium text-foreground" : "card-header"}>{selectedTable.label}</div>
                  <div className={embedded ? "mt-2 text-sm text-muted-foreground" : "card-body"}>
                    <p>Content for this table is not yet implemented. Please provide data to display.</p>
                  </div>
                </div>
              </div>
            )}
            {hasSelectedDistrict && !selectedTable && selectedTocSection && (
              <div className="col-12">
                <h3 className={embedded ? "text-lg font-semibold text-foreground" : ""}>{selectedTocSection.label}</h3>
                <p className={embedded ? "mt-2 text-sm text-muted-foreground" : ""}>
                  Content for this section is not yet implemented. Select a table or provide additional data.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );

  if (embedded) {
    return <div className="main-content space-y-6 apr-report-page">{reportContent}</div>;
  }

  return (
    <div className="page-content apr-report-page">
      {reportContent}
    </div>
  );
}

export default AprReport;
